"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.syncMenuSectionsMenuItemsMutationOptions = exports.syncMenuSectionsMutation = void 0;
const client_1 = require("@apollo/client");
const menuSections_1 = require("../queries/menuSections");
exports.syncMenuSectionsMutation = client_1.gql `
  mutation SyncMenuSections($menuSections: [MenuSectionSyncInput!]!) {
    syncMenuSections(menuSections: $menuSections) {
      ok
      errors {
        path
        message
      }
      menuSections {
        id
        name
        position
      }
    }
  }
`;
exports.syncMenuSectionsMenuItemsMutationOptions = (variables) => ({
    variables,
    update: (store, { data: dataResponse }) => {
        if (!dataResponse) {
            return;
        }
        const { syncMenuSections } = dataResponse;
        if (syncMenuSections.errors) {
            return;
        }
        const data = store.readQuery({
            query: menuSections_1.menuSectionsQuery,
        });
        if (data) {
            store.writeQuery({
                query: menuSections_1.menuSectionsQuery,
                data: Object.assign(Object.assign({}, data), { menuSections: syncMenuSections.menuSections || [] }),
            });
        }
    },
});
//# sourceMappingURL=syncMenuSection.js.map